import type { PersonnalisationMenu } from '~/utils/adminNavigation'
import type { MenuAdministrationConfig } from '~~/shared/utils/menu-administration'

/* Signature déclarée plutôt qu'inférée : voir `useCibles`. */
const charger = $fetch as unknown as (url: string) => Promise<PersonnalisationMenu>
const enregistrer = $fetch as unknown as (url: string, options: { method: 'PUT', body: MenuAdministrationConfig }) => Promise<{ config: MenuAdministrationConfig }>

/**
 * Personnalisation du menu d'administration (#332), chargée une fois.
 *
 * Clé partagée : la barre latérale, la palette et l'écran de réglage lisent la
 * même donnée, et un enregistrement les met tous à jour. Tant qu'elle n'est pas
 * arrivée — ou si l'appel échoue —, le menu par défaut s'affiche.
 */
export function useMenuAdministration() {
  const { data, refresh, status } = useAsyncData('menu-administration', () => charger('/api/admin/menu-administration').catch(() => null))

  const personnalisation = computed<PersonnalisationMenu | null>(() => data.value ?? null)

  async function sauvegarder(config: MenuAdministrationConfig) {
    await enregistrer('/api/admin/menu-administration', { method: 'PUT', body: config })
    await refresh()
  }

  return { personnalisation, refresh, status, sauvegarder }
}
